export const ENTRY_PERMISSION = ['admin', 'security'];

const displayLink = (user, __, featureToggles) => {
  return featureToggles?.EnableEhiExport === 'true';
};

export const ENTRY_LINK = {
  path: '/ehi-export-dashboard',
  text: 'EHI Export',
  module: 'ehi-export-dashboard',
  component: 'Dashboard',
  permission: ENTRY_PERMISSION,
  displayLink: displayLink,
};
